<script setup lang="ts">
import { appName } from '~/constants'

useHead({
  title: appName,
})
</script>

<template>
  <NuxtLayout>
    <div>
      <NuxtLoadingIndicator :height="4" :throttle="0" />
      <NuxtPage />
    </div>
  </NuxtLayout>
</template>

<style>
html,
body,
#__nuxt {
  height: 100vh;
  margin: 0;
  padding: 0;
  background-color: #f4f9fb;
  font-family: "Prompt", sans-serif;
}
</style>
